import { edit } from 'owa-locstrings/lib/strings/edit.locstring.json';
import loc from 'owa-localize';

import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { ControlIcons } from 'owa-control-icons';
import { FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';

/**
 * Returns the edit button on the command bar if needed
 * @param event calendar event
 */
export const getBirthdayEditButton = (
    event: CalendarEvent,
    editAction: (event: CalendarEvent) => void
): FilterableMenuItem => {
    return new FilterableMenuItem({
        [FilterableMenuItemArgs.name]: loc(edit),
        [FilterableMenuItemArgs.icon]: ControlIcons.Edit,
        [FilterableMenuItemArgs.onClick]: () => editAction(event),
        [FilterableMenuItemArgs.shouldShow]: () => {
            return event && event.PersonId != undefined;
        },
        [FilterableMenuItemArgs.key]: 'Edit',
    });
};
